<div class="custom-row">
    <div style="width: 100%;">
        @if(costumHeader){
            <ng-content></ng-content>
        }
        @if(!costumHeader){
            <mat-label>{{ title() }}</mat-label>
        }
        <quill-editor
            class="{{ showNoteBackground ? 'quill-editor-custom' : 'quill-editor-custom-simple' }}"
            [styles]="{ height: height }"
            (onFocus)="focus($event)"
            (onNativeFocus)="nativeFocus($event)"
            (onEditorChanged)="changedEditor($event)"
            (onBlur)="blur($event)"
            (onNativeBlur)="nativeBlur($event)"
            (onEditorCreated)="created($event)"
            [(ngModel)]="content"
            [modules]="quillModule"
            [placeholder]="placeholder"
            [readOnly]="readOnly"
            (onContentChanged)="onEditorContentChange($event)"
        ></quill-editor>
        @if(formControl?.hasError('required') && blurred){
            <mat-error>This field is required.</mat-error>
        }
    </div>
</div>